import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useOnlineStatus } from './hooks/useOnlineStatus';
import { useInstallPrompt } from './hooks/useInstallPrompt';
import { useServiceWorkerUpdate } from './hooks/useServiceWorkerUpdate';

// Layout Components
import Header from './components/Header';
import OnlineIndicator from './components/OnlineIndicator';
import InstallBanner from './components/InstallBanner';
import UpdateBanner from './components/UpdateBanner';

// Page Components
import Dashboard from './components/pages/Dashboard';
import NewProject from './components/pages/NewProject';
import ProjectEditor from './components/pages/ProjectEditor';
import Projects from './components/pages/Projects';

function App() {
  const isOnline = useOnlineStatus();
  const { showPrompt, installApp, dismissPrompt } = useInstallPrompt();
  const { updateAvailable, updateApp } = useServiceWorkerUpdate();

  useEffect(() => {
    console.log('Sticker Maker Admin PWA - Loaded');
    console.log('Online status:', isOnline ? 'Online' : 'Offline');
  }, [isOnline]);

  return (
    <Router>
      <div className="app min-h-screen bg-gray-50">
        {/* PWA UI Components */}
        <OnlineIndicator isOnline={isOnline} />
        {showPrompt && <InstallBanner onInstall={installApp} onDismiss={dismissPrompt} />}
        {updateAvailable && <UpdateBanner onUpdate={updateApp} />}

        {/* Main App */}
        <Header />

        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/new" element={<NewProject />} />
            <Route path="/projects/:id" element={<ProjectEditor />} />
            <Route path="/projects" element={<Projects />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
